import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import Joi from '@hapi/joi';
import { UserMappingListingSchema } from '../UserMappingSchema';
import { validate } from "../../Common";

const screenCode = 'USERMAPPING';

export function UserMappingListing(props) {
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [operationEntities, setOperationEntities] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [errors, setErrors] = useState({});
    const [mappingData, setMappingData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        description: "Operation successful"
    });
    const [searchParams, setSearchParams] = useState({
        groupID: '0',
        estate: '0',
        userRole: '0',
        user: '0'
    });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);
    const schema = Joi.object(UserMappingListingSchema).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(getPermissions());
        trackPromise(getAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(getEstatesForDropdown());
    }, [searchParams.groupID]);

    useEffect(() => {
        if (searchParams.estate !== '0') {
            trackPromise(getUserRoles());
        }
    }, [searchParams.estate]);

    useEffect(() => {
        if (searchParams.userRole !== '0') {
            trackPromise(getActiveUsers());
        }
    }, [searchParams.userRole]);

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(searchParams.groupID);
        const allowedIDs = allowedOperationEntities.map(entity => entity.OperationEntityID);
        const filtered = Object.fromEntries(
            Object.entries(data).filter(
                ([id, name]) => allowedIDs.includes(parseInt(id))
            )
        );
        setEstates(filtered);
    }
    async function getAllOperationEntityies() {
        const data = await services.GetAllOperationEntityByGroupID(searchParams.groupID);
        setOperationEntities(data);
    }


    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWUSERMAPPING');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        const token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || []);
        setSearchParams(prev => ({
            ...prev,
            groupID: token.groupID,
            estate: token.operationEntityID
        }));
    }




    const handleChange = (e) => {
        validateInputs(e.target);
        const { name, value } = e.target;

        if (name === "groupID") {
            setMappingData([]);
            setSearchParams({
                ...searchParams,
                groupID: value,
                estate: '0',
                userRole: '0',
                user: '0'
            });
        } else if (name === "estate") {
            setMappingData([]);
            setSearchParams({
                ...searchParams,
                estate: value,
                userRole: '0',
                user: '0'
            });
        } else if (name === "userRole") {
            setMappingData([]);
            setSearchParams({
                ...searchParams,
                userRole: value,
                user: '0'
            });
        } else {
            setMappingData([]);
            setSearchParams({
                ...searchParams,
                [name]: value
            });
        }
    };
    async function handleSearch(e) {
        e.preventDefault();
        getAllOperationEntityies();
        const errorMessages = validate(schema, searchParams);
        setErrors(errorMessages || {});

        if (errorMessages && Object.keys(errorMessages).length > 0) {
            console.log("Validation errors:", errorMessages);
            return;
        }



        try {
            const model = {
                groupID: parseInt(searchParams.groupID),
                estate: parseInt(searchParams.estate),
                userRole: searchParams.userRole !== '0' ? parseInt(searchParams.userRole) : null,
                user: searchParams.user !== '0' ? parseInt(searchParams.user) : null,
            };

            const response = await services.searchUserMappings(model);

            if (response.data && response.data.length > 0) {
                setMappingData(response.data);
            } else {
                setMessageModel({
                    hidden: false,
                    type: "Info",
                    description: "No records found matching your criteria"
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Info", disciption: "" });
                }, 4000);
                setMappingData([]);
            }
        } catch (error) {
            setMessageModel({
                hidden: false,
                type: "Error",
                description: "Failed to fetch user mappings"
            });
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 4000);
            console.error('Error searching user mappings:', error);
        }
    }
    function handleClear() {
        setSearchParams({
            ...searchParams,
            userRole: '0',
            user: '0'
        });
        setMappingData([]);
        setErrors({});
    }
    async function handleDelete(mappingID) {
        try {
            var model = {
                aspNetUserRoleMapping: mappingID,
                modifiedBy: parseInt(tokenService.getUserIDFromToken()),
            };


            const response = await services.deleteUserMapping(model);

            if (response.data && response.data.length > 0) {
                setMappingData(response.data);
            } else {
                setMessageModel({
                    hidden: false,
                    type: "Success",
                    description: "deleted  Successfully"
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Success", disciption: "" });
                }, 4000);
                setMappingData([]);
            }
        } catch (error) {
            setMessageModel({
                hidden: false,
                type: "Error",
                description: "Failed to fetch user mappings"
            });
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 4000);
            console.error('Error searching user mappings:', error);
        }
        model = {
            groupID: parseInt(searchParams.groupID),
            estate: parseInt(searchParams.estate),
            userRole: searchParams.userRole !== '0' ? parseInt(searchParams.userRole) : null,
            user: searchParams.user !== '0' ? parseInt(searchParams.user) : null,
        };

        const response = await services.searchUserMappings(model);
        if (response.data && response.data.length > 0) {
            setMappingData(response.data);
        } else {
            setMessageModel({
                hidden: false,
                type: "Error",
                description: "No records found matching your criteria"
            });
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 4000);
            setMappingData([]);
        }

    }


    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getUserRoles() {
        const data = await services.GetUserRoles(searchParams.estate);
        setUserRoles(data);
    }

    async function getActiveUsers() {
        const data = await services.GetActiveAspNetUser(searchParams.userRole);
        setUsers(data);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="User Mappings"
                            isButtonEnable={true}
                            buttonText="Add New Mapping"
                            path="/UserMapping/addEdit"
                        />
                        <form onSubmit={handleSearch}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchParams.groupID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="estate">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estate"
                                            id="estate"
                                            name="estate"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchParams.estate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="userRole">User Role *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="userRole"
                                            id="userRole"
                                            name="userRole"
                                            disabled={searchParams.estate === '0'}
                                            value={searchParams.userRole}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select User Role--</MenuItem>
                                            {generateDropDownMenu(userRoles)}

                                        </Select>
                                        {errors["userRole"] && <FormHelperText error>{errors["userRole"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="user">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="user"
                                            id="user"
                                            name="user"
                                            disabled={searchParams.userRole === '0'}
                                            value={searchParams.user}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}

                                        </Select>
                                        {errors["user"] && <FormHelperText error>{errors["user"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="Search"
                                            onClick={handleSearch}
                                        />
                                        <input
                                            type="button"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={handleClear}
                                        />
                                    </div>
                                </div>
                                {mappingData.length > 0 && (
                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="user mappings table">
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Allow Operation Entity</TableCell>

                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {mappingData.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center"  >{operationEntities[row.operationEntityID]}</TableCell>

                                                            <TableCell align="center" >
                                                                <IconButton
                                                                    onClick={() => handleDelete(row.aspNetUserRoleMapping)}

                                                                >
                                                                    <DeleteIcon color="error" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.description}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}